import sal from 'sal.js'
import React, {useEffect} from 'react';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import I18nProvider from '../i18n/provider';
import Contact from '../components/Contact';
import Header from '../components/HeroIcon';
import ButtonBaner from '../sections/Products/ButtonBaner';
import ExploreTools from '../sections/Products/ExploreTools';
import GreatFeatures from '../sections/Products/GreatFeatures';
import Combinations from "../sections/Products/BestCombination";
import AlertServiceProvider from '@etiquette-ui/alert-dialog';

const Container = styled.div`
    height: 100%;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ProductLayout = ({ children, data }) => {

    useEffect(() => {
        sal();
    }, []);    

    return(
        <AlertServiceProvider>
            <I18nProvider>
                <Container>
                    <Navbar />
                    <Header data={data} />
                    {children}
                    <Combinations data={data} />
                    <GreatFeatures data={data} />
                    <ButtonBaner data={data} />
                    <ExploreTools currentPage={data.currentPage} />
                    <Contact />
                    <Footer />
                </Container>
            </I18nProvider>
        </AlertServiceProvider>
    )
};


export default ProductLayout;